<style src="./ButtonRemove.scss" lang="scss" scoped></style>
<template lang="html">
  <div class="button-remove">
    <button type="button" class="button-icon" v-if="stageOfRemove === 0" @click="changeStageOfRemove(1)">
      <icon-garbage />
    </button>

    <div class="remove-confirm-container"
      v-if="stageOfRemove === 1"
      v-click-outside="cancelOperation">
      <button type="button" class="button-confirm" @click="confirmRemove">
        Remover
      </button>

      <div type="button" class="button-icon-cancel" @click="cancelOperation">
        <icon-close />
      </div>
    </div>

  </div>
</template>

<script>
import { IconGarbage, IconClose } from '@/components/primitives/icons'

export default {
  name: 'ButtonRemove',
  components: {
    IconGarbage,
    IconClose
  },
  data () {
    return {
      stageOfRemove: 0
    }
  },
  methods: {
    changeStageOfRemove (stage) {
      this.stageOfRemove = stage
    },
    cancelOperation () {
      this.stageOfRemove = 0
    },
    confirmRemove () {
      this.stageOfRemove = 0
      this.$emit('remove')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/button-remove/ButtonRemove.vue